import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';

function Sidebar() {
  const { user, activeTenant } = useSelector((state) => state.auth);
  const isAdmin = activeTenant?.role === 'admin' || user?.isGodMode;

  const linkClasses = ({ isActive }) =>
    `block px-4 py-2 rounded-lg transition ${
      isActive
        ? 'bg-primary-500 text-white'
        : 'text-gray-700 hover:bg-gray-200'
    }`;

  return (
    <aside className="w-64 bg-white shadow-sm min-h-[calc(100vh-4rem)] p-4">
      <nav className="space-y-2">
        <NavLink to="/dashboard" className={linkClasses} data-testid="nav-dashboard">
          Dashboard
        </NavLink>
        <NavLink to="/pipelines" className={linkClasses} data-testid="nav-pipelines">
          Pipelines
        </NavLink>
        <NavLink to="/data-sources" end={false} className={linkClasses} data-testid="nav-data-sources">
          Data Sources
        </NavLink>
        <NavLink to="/analytics" end={false} className={linkClasses} data-testid="nav-analytics">
          Analytics
        </NavLink>
        <NavLink to="/data-science" end={false} className={linkClasses} data-testid="nav-data-science">
          Data Science
        </NavLink>
        <NavLink to="/data-operations" end={false} className={linkClasses} data-testid="nav-data-operations">
          Data Operations
        </NavLink>
        <NavLink to="/identities" className={linkClasses} data-testid="nav-identities">
          Identities
        </NavLink>
        <NavLink to="/my-tenants" className={linkClasses} data-testid="nav-my-tenants">
          My Tenants
        </NavLink>
        {isAdmin && (
          <NavLink to="/admin" className={linkClasses} data-testid="nav-admin">
            Admin
          </NavLink>
        )}
        {isAdmin && (
          <NavLink to="/api-keys" className={linkClasses} data-testid="nav-api-keys">
            API Keys
          </NavLink>
        )}
        {user?.isGodMode && (
          <NavLink
            to="/god-mode"
            data-testid="nav-god-mode"
            className={({ isActive }) =>
              `block px-4 py-2 rounded-lg transition ${
                isActive
                  ? 'bg-purple-600 text-white'
                  : 'text-purple-700 hover:bg-purple-100'
              }`
            }
          >
            God Mode
          </NavLink>
        )}
      </nav>
    </aside>
  );
}

export default Sidebar;
